"use client";

import styles from "./styles.module.css";
import ExpandMenu from "@components/atoms/ExpandMenuButton";
import ImageContainer from "@components/atoms/ImageContainer";
import Nav from "@components/molecules/Nav";
import NavMobile from "@components/molecules/NavMobile";
import { useLocale } from "next-intl";
import Link from "next-intl/link";
import { useEffect, useState } from "react";

export default function Header() {
  const [expandMenu, setExpandMenu] = useState(false);
  const locale = useLocale();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    checkIfMobile();

    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  return (
    <header className={styles.header}>
      <div className={styles["header-elements-wrapper"]}>
        <div className={styles.header__menu}>
          <Link
            href="/"
            className={styles["header__container-link"]}
            title="Home"
            locale={locale}
          >
            <ImageContainer
              image={"/logo-labs-white.webp"}
              alt={"Web3 Services Company Logo"}
              title={"Enhance your business with WebitLabs"}
              imageStyle={styles.header__logo}
              containerStyle={styles["header__container-logo"]}
              width={286}
              height={100}
            />
          </Link>
          <ExpandMenu
            onClickEvent={() => {
              setExpandMenu(!expandMenu);
            }}
          />
        </div>
        {isMobile ? (
          <NavMobile expandMenu={expandMenu} setExpandMenu={setExpandMenu} />
        ) : (
          <Nav expandMenu={expandMenu} setExpandMenu={setExpandMenu} />
        )}
      </div>
    </header>
  );
}
